export default "__VITE_ASSET__DpolnYyn__"